import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const secretKey = process.env.REACT_APP_SECRET_KEY;

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
     
        headers.set("auth-token", `Bearer ${token}`);
     
      if (secretKey) {
        headers.set("secret-key", secretKey);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchVendors: builder.query({
      query: ({ page, position, register_status, status, vendor_type, search }) => ({
        url: "/vendors",
        params: {
          page,
          position,
          register_status,
          status,
          vendor_type,
          search,
        },
      }),
    }),
    deleteVendor: builder.mutation({
      query: (id) => ({
        url: `/vendors/delete/${id}`,
        method: "DELETE",
      }),
    }),
    createVendor: builder.mutation({
      query: (vendorData) => ({
        url: "/vendors/create",
        method: "POST",
        body: vendorData,
      }),
    }),
    updateVendor: builder.mutation({
      query: ({ id, vendorData }) => ({
        url: `/vendors/update/${id}`,
        method: "PUT",
        body: vendorData,
      }),
    }),
    createNotes: builder.mutation({
      query: (Notes) => ({
        url: "/vendors/add-notes",
        method: "POST",
        body: Notes,
      }),
    }),
    fetchContractsAuth: builder.query({ query: () => "/contracts/auth" }),
    fetchVendorNotes: builder.query({
      query: (vendorId) => ({
        url: `/vendors/vendor-notes/vendor/${vendorId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useFetchVendorsQuery,useDeleteVendorMutation ,useCreateVendorMutation, useUpdateVendorMutation
  , useFetchContractsAuthQuery,useCreateNotesMutation,useFetchVendorNotesQuery } = apiSlice;
